export default {
  setBusProducts(state, payload) {
    state.busProducts = payload;
  },
};
